import React, { useCallback, useContext, useMemo } from 'react';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { GridDate as GridDateBase } from 'components/Grid';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { endOfDay } from 'utilities';

interface GridDateProps {
  cell: ICell;
  maxDate?: string;
}

const GridDate: React.FC<GridDateProps> = ({ cell, maxDate }) => {
  const { onCellsChanged } = useContext(FeaturedSpreadsheetContext);

  const maxDateEndOfDay = useMemo(() => {
    if (!maxDate) {
      return undefined;
    }
    return endOfDay(maxDate);
  }, [maxDate]);

  const handleOnChange = useCallback(
    (date: string) => {
      onCellsChanged([{ cell, value: date }]);
    },
    [cell, onCellsChanged]
  );

  const { value, readOnly, disabled } = cell;

  return (
    <GridDateBase
      cell={cell}
      value={value as string}
      readOnly={readOnly}
      disabled={disabled}
      onCellsChanged={handleOnChange}
      maxDate={maxDateEndOfDay}
    />
  );
};

export default GridDate;